module.exports = __webpack_public_path__ + "img/arrow-up.0c5c09ac.svg";